export const reportsUpdateConstants = {
  SET_REPORTS_LAST_UPDATE: 'SET_REPORTS_LAST_UPDATE',
  SET_REPORTS_SHOULD_NOTIFY: 'SET_REPORTS_SHOULD_NOTIFY',
}
